import React from 'react';
import BrandPage from './BrandPage';

const IStorePage = () => <BrandPage brandSlug="istore" />;

export default IStorePage;
